<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCsv(titleChart)" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :zoomGraphValue="zoomGraphValue" :downloadId="downloadId" :specificSiteId="specificSiteId" :downloadShow="vizData && vizData.length > 0">
    <span slot="header" class="float-right enrol-tabs">
      <b-tabs>
        <b-tab v-for="(tabName, index) in tabListComplianceChart" :key="index" :title="tabName" @click="tabChange(tabName)" />
      </b-tabs>
    </span>
    <scatter-chart v-if="vizData && vizData.length > 0" style="width: 100%;" slot="body" :height="height" :choosenTab="choosenTab" :series="vizData" :options="options" @onDataPointClick="getBubbleDetails" :downloadId="downloadId" />
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="(dataLoaded && choosenTab !== 'Participants') || (choosenTab === 'Participants' && dataLoadedModal.vizData)">
        No Data In
      </div>
    </div>
    <modal-table
      showCloseIcon
      slot="body"
      :openModal="openModal"
      @onHideModal="hideModal"
      :titleModal="titleModal"
      :subtitleModal="subtitleModal"
      :itemsTable="itemSeries"
      :fieldsTable="fieldSeries"
      :initValueFields="initValueFields"
      :specificSiteId="specificSiteId"
      :dataLoaded="dataLoadedModal.itemSeries"
      :listSortedFields="listSortedFields"
      :listSortedMethods="listSortedMethods"
      :initNameFields="initNameFields"
      downloadId="compliance-card-modal-download"
    />
  </chart-container>
</template>

<script>
import Vue from "vue";
import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import _ from "lodash";
import { downloadCSV } from "../../services/visualization/data-management";
import moment from "moment";
import Loading from "vue-loading-overlay";
import ChartContainer from "./chart-container";
import ScatterChart from "../charts/apex/scatter-plot-apex";
import ModalTable from "./modal/modal-table";
import * as studyComplianceService from "../../services/visualization/study-compliance";

Vue.use(VueFusionCharts, FusionCharts, Loading);

const primaryColorFnc = function() {
  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#00C3B3";
  return primaryColor;
};

export default {
  components: {
    ChartContainer,
    ScatterChart,
    ModalTable
  },
  props: {
    data: { type: Array, default: () => [] },
    participantData: { type: Array, default: () => [] },
    tab: { default: 0 },
    zoomGraphValue: { type: String, default: "" },
    containerId: { type: String },
    specificSiteId: { type: Array, default: () => {} },
    titleChart: { type: String, default: "" },
    participantsSelected: [Array, String],
    countrySelected: [Array, String],
    sitesSelected: [Array, String],
    fromDate: { type: String, default: null },
    toDate: { type: String, default: null },
    countryList: { type: Array, default: () => [] },
    allSiteList: { type: Array, default: () => [] },
    studyId: { type: String, default: "" },
    typeCsv: { type: String, default: "Compliance" },
    dataLoaded: { type: Boolean, default: false },
    siteListInParticipants: { type: Array, default: () => [] }
  },
  data() {
    return {
      downloadId: "compliance-data",
      tabListComplianceChart: ["Activities", "Countries", "Sites", "Participants"],
      choosenTab: "Activities",
      width: "100%",
      height: "250px",
      zoomGraphValueChild: "",
      todayDate: "",
      tDateShow: true,
      vizData: null,
      participantDetails: null,
      loader: null,
      dataByActivity: null,
      dataByCountry: null,
      dataBySite: null,
      dataByParticipants: null,
      boundaryValue: null,
      boundaryValueByParticipants: null,
      options: null,
      openModal: false,
      itemSeries: [],
      dataLoadedModal: { vizData: true },
      fieldSeries: [],
      titleModal: "",
      subtitleModal: "",
      cacheDataSelected: {},
      cacheDateSelected: 0,
      cacheChoosenTabs: "",
      initNameFields: "activityName",
      initValueFields: "percentageComplianceRate",
      listSortedFields: ["percentageComplianceRate", "activityName"],
      listSortedMethods: ["desc", "desc"]
    };
  },

  watch: {
    data() {
      if (this.data && this.data.length > 0) {
        this.processChartData();
      } else {
        this.vizData = null;
      }
    },
    participantData() {
      if (this.participantData && this.participantData.length > 0) {
        this.resetBubbleCache();
        const { boundaryValue, bubbleData } = studyComplianceService.processComplianceDataByParticipant(this.participantData, this.countrySelected, this.sitesSelected, this.fromDate, this.toDate, "compliance");
        bubbleData[0].data = bubbleData[0].data.sort((a, b) => a[0] - b[0]);
        this.dataByParticipants = _.cloneDeep(bubbleData);
        this.boundaryValueByParticipants = boundaryValue;
        this.tabChange(this.choosenTab);
      }
    },
    countrySelected() {
      this.processChartData();
      if (this.participantData && this.participantData.length > 0) {
        this.resetBubbleCache();
        const { boundaryValue, bubbleData } = studyComplianceService.processComplianceDataByParticipant(this.participantData, this.countrySelected, this.sitesSelected, this.fromDate, this.toDate, "compliance");
        bubbleData[0].data = bubbleData[0].data.sort((a, b) => a[0] - b[0]);
        this.dataByParticipants = _.cloneDeep(bubbleData);
        this.boundaryValueByParticipants = boundaryValue;
        this.tabChange(this.choosenTab);
      }
    },
    sitesSelected() {
      this.processChartData();
      if (this.participantData && this.participantData.length > 0) {
        this.resetBubbleCache();
        const { boundaryValue, bubbleData } = studyComplianceService.processComplianceDataByParticipant(this.participantData, this.countrySelected, this.sitesSelected, this.fromDate, this.toDate, "compliance");
        bubbleData[0].data = bubbleData[0].data.sort((a, b) => a[0] - b[0]);
        this.dataByParticipants = _.cloneDeep(bubbleData);
        this.boundaryValueByParticipants = boundaryValue;
        this.tabChange(this.choosenTab);
      }
    },
    fromDate() {
      this.tabChange(this.choosenTab);
    },
    toDate() {
      this.tabChange(this.choosenTab);
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250px";
      }
    },
    specificSiteId: function() {
      if (this.specificSiteId.length > 0) {
        this.tabListComplianceChart = ["Activities", "Countries", "Participants"];
      }
    }
  },
  methods: {
    // Add index of month, so that all bubble appear
    addRangeIndexMonth(dataSources = []) {
      const tmpData = dataSources.length > 0 ? dataSources[0].data : [];
      const isNotEmptyData = Array.isArray(tmpData) && tmpData.length > 0;

      if (!isNotEmptyData) {
        return [];
      }
      //remove last metadata. Otherwise, bubble chart wont show
      if (this.choosenTab !== "Participants") {
        tmpData.forEach(d => {
          d.pop();
        });
      }
      const lastIndex = tmpData.length - 1;
      const currFirstIndexMonth = tmpData[0][0];
      const currLastIndexMonth = tmpData[lastIndex][0];
      const lastMonth = new Date(
        moment(currFirstIndexMonth)
          .subtract(10, "days")
          .format("YYYY-MM-DD")
      ).getTime();
      const nextMonth = new Date(
        moment(currLastIndexMonth)
          .add(10, "days")
          .format("YYYY-MM-DD")
      ).getTime();

      tmpData.splice(0, 0, [lastMonth, 0, 0, 0]);
      tmpData.splice(lastIndex + 2, 0, [nextMonth, 0, 0, 0]);

      dataSources[0].data = tmpData;
      return dataSources;
    },
    tabChange(tabName) {
      this.choosenTab = tabName;
      if (!this.options) {
        return;
      }
      let visData = null;
      switch (this.choosenTab) {
        case "Activities":
          visData = _.cloneDeep(this.dataByActivity);
          visData = studyComplianceService.filterVizDataByDate(visData, this.fromDate, this.toDate);
          visData = this.addRangeIndexMonth(visData);
          if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0) || (this.participantsSelected && this.participantsSelected.length === 0)) {
            this.vizData = [];
          } else {
            this.vizData = visData;
          }
          break;
        case "Countries":
          visData = _.cloneDeep(this.dataByCountry);
          visData = studyComplianceService.filterVizDataByDate(visData, this.fromDate, this.toDate);
          visData = this.addRangeIndexMonth(visData);
          if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0) || (this.participantsSelected && this.participantsSelected.length === 0)) {
            this.vizData = [];
          } else {
            this.vizData = visData;
          }
          break;
        case "Sites":
          visData = _.cloneDeep(this.dataBySite);
          visData = studyComplianceService.filterVizDataByDate(visData, this.fromDate, this.toDate);
          visData = this.addRangeIndexMonth(visData);
          if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0) || (this.participantsSelected && this.participantsSelected.length === 0)) {
            this.vizData = [];
          } else {
            this.vizData = visData;
          }
          break;
        case "Participants":
          this.dataLoadedModal.vizData = false;
          visData = _.cloneDeep(this.dataByParticipants);
          visData = studyComplianceService.filterVizDataByDate(visData, this.fromDate, this.toDate);
          visData = this.addRangeIndexMonth(visData);
          if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0) || (this.participantsSelected && this.participantsSelected.length === 0)) {
            this.vizData = [];
          } else {
            this.vizData = visData;
            this.boundaryValue = this.boundaryValueByParticipants;
          }
          this.dataLoadedModal.vizData = true;
          break;
        default:
          break;
      }
    },
    processChartData() {
      if (this.data && this.data.length > 0) {
        let { bubbleData, bubbleDataByCountry, bubbleDataBySite } = studyComplianceService.processBubbleData(this.data, this.countrySelected, this.sitesSelected, this.fromDate, this.toDate);
        this.resetBubbleCache();
        // Sorted date by asc
        bubbleData[0].data = bubbleData[0].data.sort((a, b) => a[0] - b[0]);
        bubbleDataByCountry[0].data = bubbleDataByCountry[0].data.sort((a, b) => a[0] - b[0]);
        bubbleDataBySite[0].data = bubbleDataBySite[0].data.sort((a, b) => a[0] - b[0]);
        this.dataByActivity = _.cloneDeep(bubbleData);
        this.dataByCountry = _.cloneDeep(bubbleDataByCountry);
        this.dataBySite = _.cloneDeep(bubbleDataBySite);
        this.options = {
          chart: {
            parentHeightOffset: 0,
            id: "default-bubble-",
            zoom: {
              enabled: true,
              type: "xy"
            },
            toolbar: {
              show: true,
              offsetX: 0, // decreasing this will move to the left
              offsetY: 0,
              tools: {
                download: false,
                selection: false,
                zoom: false,
                pan: false,
                zoomin: '<img src="/static/img/icon-zoomin.svg" width="35">',
                zoomout: '<img src="/static/img/icon-zoomout.svg" width="35">',
                reset: false,
                customIcons: []
              },
              autoSelected: "zoom"
            }
          },
          colors: [primaryColorFnc()],
          dataLabels: {
            enabled: false
          },
          grid: {
            xaxis: {
              lines: {
                show: false
              }
            },
            yaxis: {
              lines: {
                show: false
              }
            }
          },
          xaxis: {
            type: "datetime",
            title: {
              text: "Time Frame",
              offsetX: 0,
              offsetY: 0,
              style: {
                color: "#959fa4",
                fontSize: "10px",
                fontFamily: "RobotoRegular",
                letterSpacing: "0.5px",
                fontWeight: "500",
                cssClass: "apex-title-with-margin"
              }
            },
            labels: {
              show: true,
              format: "MMM yyyy",
              showDuplicates: false,
              style: {
                colors: "#b0bac9",
                fontSize: "10px",
                fontFamily: "Roboto-Regular",
                fontWeight: 400,
                cssClass: "to-uppercase-text"
              }
            },
            tooltip: {
              enabled: false,
              formatter: function(val, opts) {
                return moment(opts.w.globals.labels[opts.dataPointIndex]).format("MMM YYYY");
              }
            }
          },
          yaxis: {
            min: -10,
            max: 110,
            forceNiceScale: true,
            tickAmount: 6,
            axisBorder: {
              show: true,
              offsetX: -2.0
            },
            labels: {
              show: true,
              formatter: function(value) {
                return `${parseInt(value)}%`;
              },
              style: {
                colors: "#b0bac9",
                fontSize: "10px",
                fontFamily: "Roboto-Regular",
                fontWeight: 400
              }
            },
            title: {
              text: "Compliance Rate",
              rotate: -90,
              style: {
                color: "#959fa4",
                fontSize: "10px",
                fontFamily: "RobotoRegular",
                letterSpacing: "0.5px",
                fontWeight: "500",
                cssClass: "apexcharts-xaxis-title"
              }
            }
          },
          tooltip: {
            custom: ({ series, seriesIndex, dataPointIndex, w }) => {
              const backgroundColor = primaryColorFnc();
              const val = studyComplianceService.getIntRateValueFromRate(series[seriesIndex][dataPointIndex]);
              const data = _.get(w, `config.series[0].data[${dataPointIndex}]`, []);
              const activities = data[3];

              return '<div class="apex-scatter_custom-tooltips" style="background-color:' + backgroundColor + ';">' + '<span class="apex-scatter_custom-label">' + val + " Compliance</span>" + '<div class="apex-scatter_custom-tooltips-sub-label">' + activities + " " + this.choosenTab + "</div>" + '<div class="apex-scatter_custom-detail-label">Click for more details</div>' + "</div>";
            }
          }
        };
        switch (this.choosenTab) {
          case "Activities":
            bubbleData = this.addRangeIndexMonth(bubbleData);
            if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0) || (this.participantsSelected && this.participantsSelected.length === 0)) {
              this.vizData = [];
            } else {
              this.vizData = bubbleData;
            }
            break;
          case "Countries":
            bubbleDataByCountry = this.addRangeIndexMonth(bubbleDataByCountry);
            if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0) || (this.participantsSelected && this.participantsSelected.length === 0)) {
              this.vizData = [];
            } else {
              this.vizData = bubbleDataByCountry;
            }
            break;
          case "Sites":
            bubbleDataBySite = this.addRangeIndexMonth(bubbleDataBySite);
            if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0) || (this.participantsSelected && this.participantsSelected.length === 0)) {
              this.vizData = [];
            } else {
              this.vizData = bubbleDataBySite;
            }
            break;
          case "Participants":
            if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0) || (this.participantsSelected && this.participantsSelected.length === 0)) {
              this.vizData = [];
            } else {
              this.vizData = this.addRangeIndexMonth(this.dataByParticipants);
              this.boundaryValue = this.boundaryValueByParticipants;
            }
            break;
          default:
            break;
        }
      }
    },

    hideModal(open) {
      this.openModal = open;
    },

    async getComplianceDetailsEndpoint(fromDate, toDate) {
      let response = null;
      const params = { studyId: this.studyId };
      if (this.choosenTab === "Participants") {
        params["groupBy"] = "participant";
      }
      params["fromDate"] = fromDate;
      params["toDate"] = toDate;
      //   params['show'] = 'completion' // Only when get completion data
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }

      const data = await this.$api.getComplianceTable(params);
      if (data.ok) {
        response = _.get(data, "body.data", null);
      }

      return response;
    },

    async getBubbleDetails(payload) {
      const chosenData = this.vizData[0].data[payload.config.dataPointIndex]; //seriesIndex 0 = Compliance Rate. seriesIndex 1 = Completion Rate
      const [chosenTime, yaxis, radius, rate] = chosenData; // chosenData index 0 shows x Axis, index 1 shows y Axis, index 2 shows radius
      const dateString = new Date(chosenTime).toISOString().substring(0, 10);
      const fromDate = moment(chosenTime)
        .clone()
        .startOf("month")
        .format("YYYY-MM-DD");
      const toDate = moment(chosenTime)
        .clone()
        .endOf("month")
        .format("YYYY-MM-DD");
      let tableData = [];
      if (this.choosenTab === "Countries") {
        const bubbleInfo = this.dataByCountry[0].data.find(data => data[0] === chosenTime && data[1] === yaxis && data[2] === radius && data[3] === rate);
        const countryInfo = bubbleInfo[4];
        countryInfo.forEach(country => {
          tableData.push({
            date: moment(chosenTime)
              .clone()
              .startOf("month")
              .format("YYYY-MM-DD"),
            countryName: country.countryName,
            percentageComplianceRate: country.countryRate
          });
        });
      } else if (this.choosenTab === "Sites") {
        const bubbleInfo = this.dataBySite[0].data.find(data => data[0] === chosenTime && data[1] === yaxis && data[2] === radius && data[3] === rate);
        const siteInfo = bubbleInfo[4];
        siteInfo.forEach(site => {
          tableData.push({
            date: moment(chosenTime)
              .clone()
              .startOf("month")
              .format("YYYY-MM-DD"),
            siteName: site.siteName,
            percentageComplianceRate: site.siteRate
          });
        });
      } else if (this.choosenTab === "Activities") {
        const bubbleInfo = this.dataByActivity[0].data.find(data => data[0] === chosenTime && data[1] === yaxis && data[2] === radius && data[3] === rate);
        const activityInfo = bubbleInfo[4];
        activityInfo.forEach(activity => {
          tableData.push({
            date: activity.activityDate,
            activityName: activity.activityName,
            percentageComplianceRate: activity.activityRealAverage
          });
        });
      } else {
        const isDateCached = this.cacheDateSelected === chosenTime && this.cacheDataSelected && this.cacheDataSelected[this.choosenTab];
        // Only get api when have different selecting date or cache date is empty string
        if (!isDateCached) {
          this.cacheChoosenTabs = this.choosenTab;
          this.cacheDateSelected = chosenTime;
          this.cacheDataSelected[this.choosenTab] = {};
          this.cacheDataSelected[this.choosenTab] = await this.getComplianceDetailsEndpoint(fromDate, toDate);
        }
        tableData = _.cloneDeep(this.cacheDataSelected[this.choosenTab]);
      }
      const rateValue = studyComplianceService.getFilterValueFromRate(yaxis);

      await studyComplianceService.processDataForTable(tableData, rateValue, dateString, this.siteListInParticipants, this.participantsSelected, this.choosenTab, "compliance").then(dataIndexForActivities => {
        this.initNameFields = this.setFieldActivitiesValues(this.choosenTab);
        this.fieldSeries = [
          {
            label: this.setFieldActivities(this.choosenTab),
            key: this.initNameFields,
            sortable: true,
            thStyle: { width: "35%" },
            tdClass: "b_table_custom_td"
          }
        ];
        if (this.choosenTab === "Participants") {
          this.fieldSeries.push({
            label: "THREAD ID",
            key: "threadId",
            sortable: true,
            thStyle: { width: "35%" },
            tdClass: "b_table_custom_td b_table_custom_td_pr"
          });
        }
        this.fieldSeries.push({
          label: "Date",
          key: "date",
          sortable: true,
          thStyle: { width: "20%" },
          tdClass: "b_table_custom_td"
        });
        this.fieldSeries.push({
          label: "Rate",
          key: this.initValueFields,
          sortable: true,
          thStyle: {
            width: "10%"
          },
          tdClass: "b_table_custom_td_rate"
        });

        this.itemSeries = dataIndexForActivities;
        this.dataLoadedModal.itemSeries = true;
        if (this.choosenTab === "Participants") {
          this.listSortedFields = [this.initValueFields, this.initNameFields, "threadId"];
          this.listSortedMethods = ["desc", "asc", "asc"];
        } else {
          this.listSortedFields = [this.initValueFields, this.initNameFields];
          this.listSortedMethods = ["desc", "asc"];
        }
        // this.titleModal = "Study " + this.generateTableHeader(this.choosenTab) + " Compliance by Day"
        this.titleModal = "Study Activity Compliance by Day";
        this.subtitleModal = moment(dateString)
          .format("MMM YYYY")
          .toUpperCase();
        this.openModal = true;
      });
    },

    setFieldActivities(tabType) {
      switch (tabType) {
        case "Participants":
          return "Participant ID";
        case "Activities":
          return "Activity";
        case "Countries":
          return "Country";
        case "Sites":
          return "Site Name (Site ID)";
      }
    },

    setFieldActivitiesValues(tabType) {
      switch (tabType) {
        case "Participants":
          return "participantId";
        case "Activities":
          return "activityName";
        case "Countries":
          return "countryName";
        case "Sites":
          return "siteName";
      }
    },

    generateTableHeader(choosedTab) {
      let tabHeader = "";
      switch (choosedTab) {
        case "Activities":
          tabHeader = "Activities";
          break;
        case "Countries":
          tabHeader = "Countries";
          break;
        case "Sites":
          tabHeader = "Sites";
          break;
        case "Participants":
          tabHeader = "Participants";
          break;
        default:
          tabHeader = "";
          break;
      }

      return tabHeader;
    },
    downloadCsv(title) {
      if (_.isEmpty(this.vizData)) {
        return;
      }

      const data = _.cloneDeep(this.vizData[0].data);
      const dataCsv = [];
      const csvContent = [];

      const headerCsv = ["Month", "Compliance (%)", `# ${this.choosenTab}`];
      const tmpData = data;

      tmpData.shift();
      tmpData.pop();

      const orderedData = _.orderBy(tmpData, [t => t[0], r => Number(r[1])], ["asc", "asc"]);

      for (let index = 0; index < orderedData.length; index++) {
        const rate = orderedData[index][1];
        const value = orderedData[index][3];
        const date = orderedData[index][0];
        const parsedDate = moment(date)
          .format("MMM YYYY")
          .toUpperCase();

        const indexCsv = _.findIndex(dataCsv, {
          rate: studyComplianceService.generateCsvRate(rate),
          label: parsedDate
        });

        if (indexCsv > -1) {
          dataCsv[indexCsv]["value"] += value;
        } else {
          const payload = {
            label: parsedDate,
            rate: studyComplianceService.generateCsvRate(rate),
            value: value
          };

          dataCsv.push(payload);
        }
      }

      for (let i = 0; i < dataCsv.length; i++) {
        csvContent.push([dataCsv[i].label, dataCsv[i].rate, dataCsv[i].value]);
      }

      const overrideTitle = `${title}-${this.choosenTab}`;
      downloadCSV(title, headerCsv, csvContent, this.specificSiteId, overrideTitle);
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400px";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250px";
        this.$emit("zoomDisabled");
      }
    },
    resetBubbleCache() {
      this.cacheDateSelected = 0;
      this.cacheChoosenTabs = "";
      this.cacheDataSelected = {};
    }
  }
};
</script>
<style lang="scss" scoped>
#app,
.container-line-chart {
  width: 100%;
}
</style>
